import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { FailedSolutions } from './components/FailedSolutions';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { BonusGuide } from './components/BonusGuide';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans selection:bg-amber/30 selection:text-forest" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <Mechanism data-id="element-4" />
      <Deliverables data-id="element-5" />
      <Audience data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <BonusGuide data-id="element-10" />
      <Pricing data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}